import { Component, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { ReservationsService } from '@app/shared/services/reservations.service';
declare var UIkit: any;

@Component({
  selector: 'app-change-reservation-amounts',
  templateUrl: './change-reservation-amounts.component.html',
  styleUrls: ['./change-reservation-amounts.component.scss']
})
export class ChangeReservationAmountsComponent {

  public loading: boolean = true;
  public available: boolean = false;
  public invoiceFields: Array<any> = [];

  public newField: any = {
    Title: '',
    Quantity: 0,
    VAT: 0,
    ExcludingTaxes: 0,
    IncludingTaxes: 0,
    IdInvoice: 0
  };

  @Input() id: number = 0;
  @Input() reservation: any = {};
  @Output() changed = new EventEmitter();

  constructor(
    private reservationService: ReservationsService
  ) { }

  ngOnChanges() {
    if (Object.keys(this.reservation).length === 0)
      return;
    this.reloadInvoiceFields();
  }

  reloadInvoiceFields(): void {
    this.loading = true;
    this.available = false;
    this.reservationService.getReservationInvoiceFields(this.reservation.Id).then((res) => {
      if (res && res.length > 0) {
        this.invoiceFields = res;
        console.log(this.invoiceFields)
        this.newField.IdInvoice = res[0].IdInvoice;
      }
      this.available = true;
      this.loading = false;
    });
  }

  addField(): void {
    this.newField.VAT = this.newField.IncludingTaxes * 0.2;
    this.newField.ExcludingTaxes = this.newField.IncludingTaxes * 0.8;
    this.reservationService.createReservationInvoiceField(this.newField).then((res) => {
      console.log(res);

      this.invoiceFields.push(this.newField)

      this.newField = {
        Title: '',
        Quantity: 0,
        VAT: 0,
        ExcludingTaxes: 0,
        IncludingTaxes: 0,
        IdInvoice: 0
      };

      // this.reloadInvoiceFields(); //reload
    })
  }

  deleteField(field): void {
    this.reservationService.deleteReservationInvoiceField(field.IdInvoiceField).then((res) => {
      this.reloadInvoiceFields();
    })
  }

  updateInvoice(): void {
    this.invoiceFields.forEach((field) => {
      field.VAT = field.IncludingTaxes * 0.2;
      field.ExcludingTaxes = field.IncludingTaxes * 0.8;
      this.reservationService.updateReservationInvoiceField(field);
    });
    this.changed.emit();
    UIkit.modal('#change-reservation-amounts').hide();
  }
}
